import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { Coupon } from '../models/entities/coupon';
import { StoreCouponRequest } from '../requests/coupons/store-coupon.request';
import { ApiGetSuccessResponse } from '../models/common/api-get-success-response';
import { CouponsFilter } from '../store/coupons/coupons.state';

@Injectable({
  providedIn: 'root',
})
export class CouponsService {
  constructor(private apiService: ApiService) {}

  store(request: StoreCouponRequest): Promise<Coupon> {
    return this.apiService.post('coupons', request);
  }

  upload(file) {
    const formData = ApiService.buildFormData({ file });
    return this.apiService.post('coupons/upload', formData);
  }

  exportAsExcel() {
    return this.apiService.downloadFile('coupons/export');
  }

  update(id: number, request: StoreCouponRequest): Promise<Coupon> {
    return this.apiService.put(`coupons/${id}`, request);
  }

  createCode(): Observable<ApiGetSuccessResponse<string>> {
    return this.apiService.get('coupons/code');
  }

  findAll(filters: CouponsFilter): Observable<ApiGetSuccessResponse<Coupon[]>> {
    return this.apiService.get('coupons', filters);
  }

  toggleActive(id: number, active) {
    return this.apiService.put(`coupons/${id}/active`, { active });
  }

  delete(id: number) {
    return this.apiService.delete(`coupons/${id}`);
  }
}
